import PATHS from 'utils/paths'

export const QUIZ_DIAGNOSTICS_PARAMS = {
  chapterId: 'chapterId'
} as const

export const getChapterAveragesPath = () => PATHS.chapterAverages

export const getSectionAveragesPath = (chapterId: string) =>
  `${PATHS.sectionAverages}?${QUIZ_DIAGNOSTICS_PARAMS.chapterId}=${chapterId}`

export const isAveragesPath = (pathname: string) =>
  pathname === PATHS.chapterAverages ||
  pathname === PATHS.sectionAverages ||
  pathname === PATHS.quizDiagnostics
